import { get } from '../fetch';

const apiGetCustomers = ( setCustomers, dispatch ) => {
    get( 'apiGetCustomers', '/api/customers', 
        setCustomers, dispatch
    )
}

export default apiGetCustomers